import React from "react";
import "./AudioBox.scss";
import { IoCloseCircleOutline } from "react-icons/io5";

const DOMAIN = process.env.REACT_APP_API_URL;

const AudioBox = ({ audioLink, closeAudioBox }: any) => {
  //console.log(file);
  const audioSrc = `${DOMAIN}/media/${audioLink}`;

  return (
    <div className="audio-box">
      <IoCloseCircleOutline
        className="audio-box-icon"
        //arial-label="Close modal"
        onClick={closeAudioBox}
      />
      <div className="audio-box-inner">
        <span className="loader"></span>
        <audio
          className="audio-box-inner-container"
          controls
          onCanPlay={() => console.log("Audio is ready to play")}
          onError={(e) => console.error("Error loading audio:", e)}
        >
          <source src={audioSrc} />
          Your browser does not support the audio element.
        </audio>
      </div>
    </div>
  );
};

export default AudioBox;
